import { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import moment from 'moment'
import 'moment/locale/pt-br'
import 'rsuite/dist/styles/rsuite-default.css'
import Corpobackup from '../../components/CorpoBackups'
import api from '../../services/api'
import Loading from '../Global/Loading'
import { IconButton } from 'rsuite'

export default function FixedColumnTable({ day, name }) {
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - day)
  const [body, setBody] = useState([])
  const [date, setDate] = useState(
    moment().subtract(day, 'days').calendar(true)
  )
  const [check, setCheck] = useState()
  const [field, setField] = useState('')
  const [bgColor, setBgColor] = useState('')
  const [loading, setLoading] = useState(true)

  const getData = async () => {
    await api
      .get(`/backups?name=${name}&data=${yesterday}`)
      .then(({ data, status }) => {
        if (status === 204) setBody([])
        setBody(data)
        setLoading(false)
      })
  }

  const getToday = async () => {
    await api
      .get(`/backups?name=${name}&data=${today}`)
      .then(({ data, status }) => {
        if (status === 204) setBody([])
        setBody(data)
        setLoading(false)
      })
  }

  useEffect(() => {
    if (!day) {
      getToday()
    } else {
      getData()
    }
  }, [])

  return (
    <div>
      <Loading value={loading} />
      {body[0] && (
        <Table responsive hover size="sm">
          <thead>
            <tr>
              <td colSpan="2" style={{ textAlign: 'center' }}></td>
              <td
                colSpan="4"
                style={{
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: 'bold',
                }}
              >
                {date}
              </td>
            </tr>

            <tr>
              <td>HOST</td>
              <td>Backup</td>
              <td>Field</td>
              <td>Status</td>
              <td>Conferido</td>
            </tr>
          </thead>
          {body
            .sort((a, b) => a.backup.localeCompare(b.backup))
            .map((body) => {
              return <Corpobackup key={body.id} data={body} />
            })}
          <br />
        </Table>
      )}
    </div>
  )
}
